/**
 * Salas de ticket alinhadas ao Socket.IO do Node e ao WebSocket Go.
 * @param {number|string|null|undefined} companyId
 * @param {string|null|undefined} status
 */
export function ticketStatusSocketRoom(companyId, status) {
	if (!status) return null;
	if (companyId != null && companyId !== "") {
		return `company-${companyId}-${status}`;
	}
	return `tickets-${status}`;
}

export function isSameTicketCompany(ticket, userCompanyId) {
	if (userCompanyId == null || userCompanyId === "") return false;
	if (ticket?.companyId == null) return false;
	return String(ticket.companyId) === String(userCompanyId);
}
